import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from '../../shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { ConsultarPagosProveedorModalViewDetailsComponent } from './modal-view-details/modal-view-details.component';
import { DatesService } from 'src/app/shared/services/dates.service';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import * as _ from 'lodash';
@Component({
  selector: 'consultar-pagos-proveedores-pagos',
  templateUrl: './consultar-pagos-proveedores.component.html',
  styleUrls: ['./consultar-pagos-proveedores.component.scss'],
  providers: [SecurityService],
})
export class ConsultarPagosProveedoresComponent implements OnInit {
  // Modales
  @ViewChild(ConsultarPagosProveedorModalViewDetailsComponent, { static: true }) modalVerPago: ConsultarPagosProveedorModalViewDetailsComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private currentPayload: any = null;
  proveedorSeleccionado: any = null;
  listaMovimientos: any = null;
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  headerData: any = {};

  // Utils
  private log: any;
  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private datesService: DatesService,
    private messageRendererService: MessageRendererService,
    private pagoService: PagoService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('CONSULTA-PAGO-PROVEEDORES');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      fecha_desde: [initDate, [Validators.required]],
      fecha_hasta: [currentDate, [Validators.required]],
      rutProveedor: [null, []],
      codigo: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut);
      });
  }

  openModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data }) {
    this.proveedorSeleccionado = data;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rutProveedor').setValue(this.rutService.AgregarDV(this.proveedorSeleccionado.rut));
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;
    this.clearProveeData();
  }
  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }
  clearContent() {
    this.headerData = {};
    // this.formValidatorsService.reset(this.formHeader);
  }

  buscar(pageNumber: number = 1) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber;

    this.listaMovimientos = [];

    const { fecha_desde, fecha_hasta, codigo } = this.formHeader.value;

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fecha_desde ? fecha_desde : null,
        fecha_hasta: fecha_hasta ? fecha_hasta : null,
        cliente_proveedor_rut: this.proveedorSeleccionado ? this.proveedorSeleccionado.rut : -1,
        codigo: codigo ? codigo : -1,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.currentPayload = inputParams;

    this.loading = true;
    this.pagoService.obtenerPagosParaConsultaProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.paginationContext.RecordsCount = totalRegistros;
      this.paginationContext.CurrentPage = paginaActual;
      this.paginationContext.PagesCount = totalPaginas;
      this.listaMovimientos = registros;

      this.listaMovimientos.forEach((p) => {
        p.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor_rut);
        p.rutRecaudadorFormato = this.rutService.AgregarDV(p.rut_recaudador);
      });

      this.loading = false;
    });
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';
    // inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams));

    // this.pagoService.obtenerPagosParaConsultaExcel(inputParams, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }
    //   if (respuesta)
    //     this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    // })
  }

  loadAndShowPago({ codigo, cliente_proveedor_rut }) {
    this.modalVerPago.loadAndShow(codigo, cliente_proveedor_rut);
  }
}
